import React from "react";
import DownloadIcon from "./DownloadIcon";
import ExitIcon from "./ExitIcon";
import PrintIcon from "./PrintIcon";

import {
  BrowserView,
  MobileView,
  isTablet,
  isMobile
} from "react-device-detect";
import MobilePdfConsole from "./MobilePdfConsole";

import "../style/Modal.css";
const Modal = (srcForIframe, closeFunction, downloadFn, titleOfPiece) => {
  console.log(titleOfPiece);
  const body = document.querySelectorAll("body")[0];
  const isFirefox = typeof InstallTrigger !== "undefined";
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isEdge = window.navigator.userAgent.indexOf("Edge") > -1;
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  if (!isFirefox && !isSafari && !isEdge && !isIE11 && !isMobile && !isTablet) {
    body.classList.add("freeze");
  }
  console.log("isSafari", isSafari);
  return (
    <div>
      <BrowserView>
        <div
          className={`modal-container--${
            isFirefox ? "firefox" : ""
          } modal-container--${isEdge ? "edge" : ""}${
            isIE11 ? "modal-container--ie" : ""
          }`}
        >
          <div
            className={`modal-backdrop ${
              isFirefox ? "modal-backdrop_firefox" : ""
            } ${isSafari ? "modal-backdrop_safari" : ""} ${
              isEdge ? "modal-backdrop_edge" : ""
            } ${isIE11 ? "modal-backdrop_ie11" : ""}`}
            onClick={closeFunction}
          />
          <div
            className={`modal ${isFirefox ? "modal_firefox" : ""} ${
              isSafari ? "modal_safari" : ""
            } ${isEdge ? "modal_edge" : ""} ${isIE11 ? "modal_ie11" : ""}`}
          >
            <div
              className={`iframe-cover ${
                isFirefox ? "iframe-cover_firefox" : ""
              } ${isSafari ? "iframe-cover_safari" : ""} ${
                isEdge ? "iframe-cover_edge" : ""
              }`}
            />
            <iframe
              title={"Music Viewer"}
              className="modal-iframe"
              src={srcForIframe}
            />
            <div className="btn-holder btn-holder_modal">
              <button className="exit-btn" onClick={closeFunction}>
                <ExitIcon />
              </button>
              <button className="download-btn" onClick={downloadFn}>
                <DownloadIcon />
              </button>
              <button
                className="download-btn"
                id="print-btn"
                onClick={() =>
                  document.querySelector("iframe").contentWindow.print()
                }
              >
                <PrintIcon />
              </button>
            </div>
          </div>
        </div>
      </BrowserView>
      <MobileView>
        <MobilePdfConsole pdf={titleOfPiece}>
          <div
            onClick={closeFunction}
            className={`mobile-pdf-console-backdrop ${
              isSafari ? "mobile-pdf-console-backdrop--safari" : ""
            }`}
          />
          <button className="download-btn" onClick={downloadFn}>
            <DownloadIcon />
          </button>
          <div className="mobile-pdf-console-title">{titleOfPiece}</div>

          <button className="exit-btn" onClick={closeFunction}>
            <ExitIcon />
          </button>
        </MobilePdfConsole>
      </MobileView>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js